import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FileList from "./FileList";
import TextareaAutosize from 'react-autosize-textarea';
import CustomScrollbars from './CustomScrollbars/CustomScrollbars';


export default class TextInputBlock extends React.Component {

    constructor(props) {

        super(props);
        this.setTextareaRef = this.setTextareaRef.bind(this);
    }
    rtl = ['ar', 'he', 'fa', 'ur'];
    render() {

        const hasFiles = this.props.files.length;
        const hasText = this.props.text;

        return (

                <div className="amt-input-text" style={this.props.styled.inputText || {}}>
                    <CustomScrollbars style={{ width: "100%", height: 83 }} document={this.props.document}>
                    {
                        <div>
                            <div className="textarea-wrapper" onClick={() => this.focusOnTextarea()}>
                                {
                                !hasText ?
                                this.placeholder()
                                : null
                                }
                                <TextareaAutosize className="amt-text-area" innerRef={this.setTextareaRef} disabled={hasFiles}
                                                    onChange={this.props.onTextInput}
                                                    rows={2}
                                                    value={this.props.text}
                                                    dir={  this.rtl.includes(this.props.srcLang.id)
                                                        ? 'rtl'
                                                        : 'ltr'}
                                                    style={this.props.styled.inputText && this.props.styled.inputText.backgroundColor ? {backgroundColor: this.props.styled.inputText.backgroundColor} : {}}>
                                </TextareaAutosize>
                            </div>
                            { hasFiles
                            ? (
                                <FileList files={this.props.files} onFileRemove={this.props.onFileRemove}/>
                            )  :
                                null
                            }

                        </div>

                    }
                    </CustomScrollbars>
                    {
                        (hasText && !hasFiles) ? (
                                                 <div className="amt-text-controls"><span onClick={this.props.onTextClear}><FontAwesomeIcon
                                                     icon="times"/></span></div>
                                             ) :
                        (
                            null
                        )
                    }
                </div>
        );
    }

    setTextareaRef(node) {
        this.textareaRef = node;
    }

    focusOnTextarea() {
        if (this.textareaRef) {
            this.textareaRef.focus();
        }
    }

    fileControls() {

        return (
            <div className="amt-files-controls" onClick={(e) => e.stopPropagation()}>
                <label className="amt-load-file" htmlFor="amt-file-input">
                    upload file...
                </label>
                <input type="file" id="amt-file-input" onChange={this.props.onFileAdd}
                       multiple="multiple"/>
            </div>
        );
    }

    placeholder() {

        const canUpload = this.props.canUpload;
        const hasFiles = this.props.files.length;

        return (
            <div className="input-placeholder">
                { !hasFiles ? (
                    <div>Type/paste text here {canUpload ? <span>or drop/{this.fileControls()}</span> : <span>...</span>}</div>
                    ) : (
                        <span>Drop/{this.fileControls()}</span>
                    )
                }
            </div>
        );
    }
}
